module.exports = __webpack_public_path__ + "img/export4.637a2240.png";